import React from "react";
import {  message, Tooltip } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { printdocpdf } from "../Services/PrintDocService";

const ExportPdf = ({ numdoc}) => {
  const exportToPDF = () => {
    printdocpdf(numdoc);
    message.success("impression réussi !")
  };

  const handleExport = () => {
    exportToPDF();
  };



  return (
    <Tooltip title="PDF">
      <PrinterOutlined  size="small" style={{ cursor: 'pointer', color: '#67f02e', marginRight: 8 }} onClick={handleExport} />
    </Tooltip>
  );
};

export default ExportPdf;